import { DocumentBirthVM } from 'civil-status/view-models/document-birth-list';
import { DocumentCitizenshipVM } from 'civil-status/view-models/document-citizenship-list';
import { DocumentCivilUnionVM } from 'civil-status/view-models/document-civil-union-list';
import { DocumentDeathVM } from 'civil-status/view-models/document-death-list';
import { DocumentMarriageVM } from 'civil-status/view-models/document-marriage-list';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCellsDocumentBirth: HeadCell<DocumentBirthVM, keyof DocumentBirthVM>[] = [
  {
    id: 'code',
    label: 'Matricola',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'year',
    label: 'Anno',
  },
  {
    id: 'numReg',
    label: 'Registro',
  },
  {
    id: 'documentNumber',
    label: 'Atto',
  },
  {
    id: 'parte',
    label: 'Parte',
  },
  {
    id: 'serie',
    label: 'Serie',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];

export const headCellsDocumentMarriage: HeadCell<DocumentMarriageVM, keyof DocumentMarriageVM>[] = [
  {
    id: 'registerNumberWife',
    label: 'Matricola',
  },
  {
    id: 'surnameWife',
    label: 'Cognome',
  },
  {
    id: 'nameWife',
    label: 'Nome',
  },
  {
    id: 'registerNumberHusband',
    label: 'Matricola',
  },
  {
    id: 'surnameHusband',
    label: 'Cognome',
  },
  {
    id: 'nameHusband',
    label: 'Nome',
  },
  {
    id: 'year',
    label: 'Anno',
  },
  {
    id: 'numReg',
    label: 'Registro',
  },
  {
    id: 'documentNumber',
    label: 'Atto',
  },
  {
    id: 'parte',
    label: 'Parte',
  },
  {
    id: 'serie',
    label: 'Serie',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];

export const headCellsDocumentDeath: HeadCell<DocumentDeathVM, keyof DocumentDeathVM>[] = [
  {
    id: 'code',
    label: 'Matricola',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'year',
    label: 'Anno',
  },
  {
    id: 'numReg',
    label: 'Registro',
  },
  {
    id: 'documentNumber',
    label: 'Atto',
  },
  {
    id: 'parte',
    label: 'Parte',
  },
  {
    id: 'serie',
    label: 'Serie',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];

export const headCellsDocumentCivilUnion: HeadCell<
  DocumentCivilUnionVM,
  keyof DocumentCivilUnionVM
>[] = [
  {
    id: 'code',
    label: 'Matricola',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'code2',
    label: 'Matricola',
  },
  {
    id: 'surname2',
    label: 'Cognome',
  },
  {
    id: 'name2',
    label: 'Nome',
  },
  {
    id: 'year',
    label: 'Anno',
  },
  {
    id: 'numReg',
    label: 'Registro',
  },
  {
    id: 'documentNumber',
    label: 'Atto',
  },
  {
    id: 'parte',
    label: 'Parte',
  },
  {
    id: 'serie',
    label: 'Serie',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];

export const headCellsDocumentCitizenship: HeadCell<
  DocumentCitizenshipVM,
  keyof DocumentCitizenshipVM
>[] = [
  {
    id: 'code',
    label: 'Matricola',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'year',
    label: 'Anno',
  },
  {
    id: 'numReg',
    label: 'Registro',
  },
  {
    id: 'documentNumber',
    label: 'Atto',
  },
  {
    id: 'parte',
    label: 'Parte',
  },
  {
    id: 'serie',
    label: 'Serie',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
